/**
 * The cartoon pictures, mirroring `tutor_core::picture::PRESETS` slug for slug
 * and in the same order; `//client:picture_presets_contract_test` holds the
 * two lists to one (learner picture PRD §4). Append-only: the slug is what the
 * server stores, so renaming one resets everyone who chose it.
 */
import type { PlainKey } from '../i18n/t.ts';

export const PRESET_SLUGS = [
  'fox',
  'owl',
  'cat',
  'bear',
  'panda',
  'rabbit',
  'penguin',
  'frog',
  'whale',
  'rocket',
  'star',
  'robot',
] as const;

export type PresetSlug = (typeof PRESET_SLUGS)[number];

export function isPresetSlug(slug: string): slug is PresetSlug {
  return (PRESET_SLUGS as readonly string[]).includes(slug);
}

export function presetName(slug: PresetSlug): PlainKey {
  return `picture-preset-${slug}`;
}
